/** Os passos do guia de boas-vindas: só o que quem lê dashboards usa no dia a dia. */
export interface Passo {
  id: string
  /** Valor do atributo data-guia do elemento que o passo destaca; sem alvo, o passo abre no centro da tela. */
  alvo?: string
  titulo: string
  texto: string
  /** Lista curta de dicas, para os passos que falam de coisas que ficam dentro das telas. */
  dicas?: string[]
  /** O passo só aparece para quem tem alguma destas permissões. */
  claims?: string[]
}

// Quem vê o item Solicitações no menu (CascaNova). O guia só fala de chamados para quem tem a tela.
const CLAIMS_SOLICITACOES = ['solicitacoes', 'gestao_solicitacoes', 'bi_dashboards_read_any']

export const PASSOS: Passo[] = [
  {
    id: 'boas-vindas',
    titulo: 'Bem-vindo ao novo portal',
    texto: 'Reformulamos o portal para você chegar mais rápido aos seus dashboards. Este guia leva menos de um minuto e mostra o básico.'
  },
  {
    id: 'inicio',
    alvo: 'inicio',
    titulo: 'Seu ponto de partida',
    texto: 'O Início reúne seus favoritos, o que você abriu por último e os ambientes que você acompanha.',
    claims: ['showmenu_bi_dashboards']
  },
  {
    id: 'busca',
    alvo: 'busca',
    titulo: 'Ache qualquer dashboard',
    texto: 'Digite o nome do dashboard e vá direto a ele, de qualquer tela. O atalho é Ctrl K (Cmd K no Mac).',
    claims: ['bi_dashboards_read', 'bi_dashboards_read_any']
  },
  {
    id: 'dashboards',
    alvo: 'dashboards',
    titulo: 'Todos os seus dashboards',
    texto: 'Escolha o ambiente e o painel que quiser. A estrela guarda um dashboard nos favoritos, para abrir em um clique.',
    claims: ['showmenu_bi_dashboards']
  },
  {
    id: 'solicitacoes',
    alvo: 'solicitacoes',
    titulo: 'Precisa de algo do time de BI?',
    texto: 'Peça acesso, um dashboard novo ou um ajuste em Solicitações e acompanhe o andamento por lá, sem e-mail nem planilha.',
    claims: CLAIMS_SOLICITACOES
  },
  {
    id: 'avisos',
    alvo: 'avisos',
    titulo: 'Avisos do que mudou',
    texto: 'Quando uma solicitação sua anda ou recebe uma resposta, o sino mostra um número. Um clique leva você ao que mudou.',
    // Os avisos do sino são das solicitações: sem a tela, o passo indicaria algo que a pessoa não usa.
    claims: CLAIMS_SOLICITACOES
  },
  {
    id: 'menu',
    alvo: 'recolher',
    titulo: 'Mais espaço para o dashboard',
    texto: 'Recolha o menu para deixar só os ícones e dar mais tela ao relatório. O portal lembra a sua escolha.'
  },
  {
    id: 'fim',
    titulo: 'Dentro de um dashboard',
    texto: 'Alguns recursos ficam dentro da tela do dashboard:',
    dicas: [
      'A estrela ao lado do nome do dashboard o coloca nos seus favoritos.',
      'Onde o ambiente tem o oneflow, o botão no canto abre o assistente para conversar sobre os dados.',
      'O botão de tela cheia dá o máximo de espaço ao relatório.'
    ]
  }
]

/** Passos que fazem sentido para a pessoa: os sem restrição e os que combinam com uma das suas permissões. */
export function passosDaPessoa(roles: string[], todos: Passo[] = PASSOS): Passo[] {
  return todos.filter(p => !p.claims || p.claims.some(c => roles.includes(c)))
}
